import './card-popup.scss';

export default () => {

};
